import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"];

  connect() {
    window.googlefc = window.googlefc || {};
    window.googlefc.callbackQueue = window.googlefc.callbackQueue || [];

    window.googlefc.callbackQueue.push({
      // GDPRの規定で同意を撤回するリンクを表示する必要があるため
      // 下記APIを使用してGDPR適応地域であるかを確認し、表示制御を行う
      "CONSENT_API_READY": () => {
        if (typeof window.__tcfapi !== "function") return;
        window.__tcfapi("addEventListener", 0, (tcdata, success) => {
          if (success && tcdata.gdprApplies) this.linkTarget.style.display = "block";
        });
      }
    });
  }
}
